module.exports = __webpack_public_path__ + "static/media/NotoSansCJKtc-Light.619f044b.svg";